/* 導入施設一覧（/pages/placement）— Storefront API からメタオブジェクト facility を取得して描画する。
 * KINUJO ROOM のページ（/pages/kinujo-room）の「認定施設」も、このスクリプトで 種別「KINUJO ROOM」を描画する。
 *
 * 背景（2026-09-20）:
 *   現行ページは227施設をHTMLに直書きしていて、追加・修正のたびに作業が必要だった。
 *   9/8のMTGで「ホテル・サウナ／ゴルフ場もサロンと同じく管理画面から編集できる形に」と決定。
 *   Liquid の shop.metaobjects はループが50件までで一覧を組めないため（2026-09-05 実測）、
 *   ガワ（セクション見出し・アコーディオン）だけを移植し、中身はここで描画する。
 *
 * 表示順:
 *   都道府県は現行ページの並び（ビルド時に data-facility-prefs へ書き出し）をそのまま踏襲する。
 *   そこに無い都道府県（新しく追加されたもの）は末尾に都道府県コード順で足す。
 *   同じ都道府県の中は 表示順（sort_order）の昇順、同値なら施設名。
 *
 * 非公開（DRAFT）のエントリは Storefront API から返らないため、公開分だけが自動的に並ぶ。
 * 公開日（publish_date・2026-10-15 追加）が未来のものは、その日になるまで出さない。
 */
(function () {
  var CFG = window.KINUJO_FACILITY;
  if (!CFG || !CFG.token) return;

  var ENDPOINT = 'https://' + CFG.domain + '/api/' + CFG.version + '/graphql.json';
  var CACHE_KEY = 'kinujo_facility_v1';
  var CACHE_TTL = 30 * 60 * 1000; // 30分

  var PREF_ORDER = [
    '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
    '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
    '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
    '岐阜県', '静岡県', '愛知県', '三重県',
    '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
    '鳥取県', '島根県', '岡山県', '広島県', '山口県',
    '徳島県', '香川県', '愛媛県', '高知県',
    '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
  ];

  /* 現行ページの見出しは「東京」「大阪」など短縮表記。メタオブジェクト側は正式名で持っている */
  function shortPref(full) {
    if (full === '北海道') return full;
    return full.replace(/[都道府県]$/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function gql(query, variables) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  var QUERY = [
    'query Q($after: String) {',
    '  metaobjects(type: "facility", first: 250, after: $after) {',
    '    nodes { handle fields { key value } }',
    '    pageInfo { hasNextPage endCursor }',
    '  }',
    '}'
  ].join('\n');

  function fetchAll() {
    var out = [];
    function page(after) {
      return gql(QUERY, { after: after }).then(function (res) {
        if (!res || !res.data) throw new Error('取得に失敗しました');
        var d = res.data.metaobjects;
        d.nodes.forEach(function (n) {
          var o = {};
          n.fields.forEach(function (f) { if (f.value) o[f.key] = f.value; });
          out.push(o);
        });
        if (d.pageInfo.hasNextPage) return page(d.pageInfo.endCursor);
        return out;
      });
    }
    return page(null);
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || Date.now() - o.t > CACHE_TTL) return null;
      return o.d;
    } catch (e) { return null; }
  }

  function writeCache(d) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* 容量超過は無視 */ }
  }

  /* 公開日（publish_date・日付）が未来のエントリは、その日の0時（日本時間）まで出さない。空欄は即表示 */
  function todayJST() {
    return new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
  }
  function isPublished(o) {
    return !o.publish_date || o.publish_date <= todayJST();
  }

  function facilityItem(f) {
    if (f.url) {
      return '<li>' + esc(f.name) + '<a href="' + esc(f.url) + '" rel="external" target="_blank">'
        + esc(f.url) + '</a></li>';
    }
    return '<li>' + esc(f.name) + '</li>';
  }

  function prefBlock(pref, items) {
    items.sort(function (a, b) {
      var d = (parseInt(a.sort_order, 10) || 0) - (parseInt(b.sort_order, 10) || 0);
      return d !== 0 ? d : String(a.name).localeCompare(String(b.name), 'ja');
    });
    return '<li class="accordion__group__item">'
      + '<div class="accordion__group__item__hed"><h4>' + esc(shortPref(pref)) + '</h4></div>'
      + '<ul class="accordion__group__item__content">' + items.map(facilityItem).join('') + '</ul>'
      + '</li>';
  }

  function render(list) {
    var boxes = document.querySelectorAll('[data-facility-category]');
    Array.prototype.forEach.call(boxes, function (box) {
      var cat = box.getAttribute('data-facility-category');
      var order = (box.getAttribute('data-facility-prefs') || '').split(',').filter(Boolean);

      var byPref = {};
      list.forEach(function (f) {
        if (f.category !== cat || !f.prefecture || !isPublished(f)) return;
        (byPref[f.prefecture] = byPref[f.prefecture] || []).push(f);
      });

      // 現行ページの並び → そこに無い県は都道府県コード順で末尾に足す
      var prefs = order.filter(function (p) { return byPref[p]; });
      PREF_ORDER.forEach(function (p) {
        if (byPref[p] && prefs.indexOf(p) === -1) prefs.push(p);
      });

      box.innerHTML = '<ul class="accordion__group__items">'
        + prefs.map(function (p) { return prefBlock(p, byPref[p]); }).join('')
        + '</ul>';

      // KINUJO ROOM（2026-10-15 追加）は施設が1件も公開されていない間、見出しごと隠しておく
      var show = prefs.length > 0;
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-facility-hed="' + cat + '"], [data-facility-wrap="' + cat + '"]'),
        function (el) { el.style.display = show ? '' : 'none'; }
      );
      // KINUJO ROOM のページ（/pages/kinujo-room・2026-10-16 追加）の「順次掲載」の文言は逆に、0件のときだけ出す
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-facility-empty="' + cat + '"]'),
        function (el) { el.style.display = show ? 'none' : ''; }
      );
    });
  }

  function setStatus(msg) {
    var el = document.getElementById('js-facility-status');
    if (el) el.textContent = msg;
  }

  function boot() {
    var cached = readCache();
    if (cached) {
      render(cached);
      setStatus('');
      return;
    }
    setStatus('施設情報を読み込んでいます…');
    fetchAll()
      .then(function (list) {
        render(list);
        writeCache(list);
        setStatus('');
      })
      .catch(function (e) {
        setStatus('施設情報を読み込めませんでした。時間をおいて再度お試しください。');
        if (window.console) console.error('[placement]', e);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
